var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    transition: "transform 0.5s ease-in-out",
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 2,
    transform: "rotate(-180 32 32)",
    fill: "#FBFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.175 21.1708L16 17.3458L19.825 21.1708L21 19.9958L16 14.9958L11 19.9958L12.175 21.1708ZM21 10.8292L21 12.4958L11 12.4958L11 10.8292L21 10.8292Z",
    fill: "#2A2859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonUp);
export default __webpack_public_path__ + "static/media/ButtonUp.25abee9c2c46103f3387860ab84c2516.svg";
export { ForwardRef as ReactComponent };